import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Alert, Avatar, Button, Dropdown, Empty, Input, Form, Select, Modal, Skeleton, Spin, Tag, message } from 'antd';
import { MoreOutlined, PlusOutlined, PushpinOutlined } from '@ant-design/icons';
import { PrimaryButton, ReloadButton, RichTextEditor, SecondaryButton, TextLinkButton } from '@lib/common';
import { ClassAnnouncementReferences } from './class-announcement-references.component';
import { AnnouncementCard, Composer, Feed, Header, Panel, RichContent } from './class-dashboard.styles';
import { ClassAnnouncementListLayout } from './class-announcement-list-layout.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ClassAnnouncementPreviewLayout = function ClassAnnouncementPreviewLayout(_ref) {
  var title = _ref.title,
      hint = _ref.hint,
      actions = _ref.actions,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(Panel, {
    children: [/*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h3", {
          children: title
        }), /*#__PURE__*/_jsx("p", {
          children: hint
        })]
      }), actions]
    }), children]
  });
};

export var ClassAnnouncements = function ClassAnnouncements(_ref2) {
  var _references$;

  var classId = _ref2.classId,
      api = _ref2.api,
      author = _ref2.author,
      _ref2$profiles = _ref2.profiles,
      profiles = _ref2$profiles === void 0 ? [] : _ref2$profiles,
      labels = _ref2.labels,
      editorLabels = _ref2.editorLabels,
      _ref2$readOnly = _ref2.readOnly,
      readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
      loadReferenceAssignments = _ref2.loadReferenceAssignments,
      resolveReference = _ref2.resolveReference,
      _ref2$mode = _ref2.mode,
      mode = _ref2$mode === void 0 ? 'preview' : _ref2$mode,
      onViewAll = _ref2.onViewAll;

  var label = function label(key) {
    return labels[key] || key;
  };

  var _useState = useState([]),
      items = _useState[0],
      setItems = _useState[1];

  var _useState2 = useState(false),
      ready = _useState2[0],
      setReady = _useState2[1];

  var _useState3 = useState(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var _useState4 = useState(null),
      nextToken = _useState4[0],
      setNextToken = _useState4[1];

  var _useState5 = useState(null),
      error = _useState5[0],
      setError = _useState5[1];

  var _useState6 = useState(false),
      busy = _useState6[0],
      setBusy = _useState6[1];

  var _useState7 = useState(false),
      composerOpen = _useState7[0],
      setComposerOpen = _useState7[1];

  var _useState8 = useState(''),
      title = _useState8[0],
      setTitle = _useState8[1];

  var _useState9 = useState(''),
      content = _useState9[0],
      setContent = _useState9[1];

  var _useState10 = useState([]),
      references = _useState10[0],
      setReferences = _useState10[1];

  var _useState11 = useState(''),
      referenceSearch = _useState11[0],
      setReferenceSearch = _useState11[1];

  var _useState12 = useState([]),
      referenceOptions = _useState12[0],
      setReferenceOptions = _useState12[1];

  var _useState13 = useState(null),
      referenceNextToken = _useState13[0],
      setReferenceNextToken = _useState13[1];

  var _useState14 = useState(false),
      referenceLoading = _useState14[0],
      setReferenceLoading = _useState14[1];

  var _useState15 = useState(null),
      referenceError = _useState15[0],
      setReferenceError = _useState15[1];

  var referenceGeneration = useRef(0);
  var referenceLoadingRef = useRef(false);

  var _useState16 = useState(null),
      editing = _useState16[0],
      setEditing = _useState16[1];

  var _useState17 = useState(null),
      selected = _useState17[0],
      setSelected = _useState17[1];

  var _useState18 = useState(false),
      detailLoading = _useState18[0],
      setDetailLoading = _useState18[1];

  var _useState19 = useState(null),
      detailError = _useState19[0],
      setDetailError = _useState19[1];

  var _useState20 = useState(0),
      editorVersion = _useState20[0],
      setEditorVersion = _useState20[1];

  var feedRef = useRef(null);
  var sentinelRef = useRef(null);
  var generation = useRef(0);
  var loadingRef = useRef(false);
  var selectedId = useRef(null);
  var changes = useRef(new Map());
  var loadReferences = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(search, cursor) {
      var current, page;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!loadReferenceAssignments || referenceLoadingRef.current)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              referenceLoadingRef.current = true;
              current = referenceGeneration.current;
              setReferenceLoading(true);
              setReferenceError(null);
              _context.prev = 6;
              _context.next = 9;
              return loadReferenceAssignments(search, cursor);

            case 9:
              page = _context.sent;

              if (!(current !== referenceGeneration.current)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return");

            case 12:
              setReferenceOptions(function (previous) {
                return Array.from(new Map((cursor ? [].concat(_toConsumableArray(previous), _toConsumableArray(page.items)) : page.items).map(function (item) {
                  return [item.entityId, item];
                })).values());
              });
              setReferenceNextToken(page.nextToken || null);
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](6);
              if (current === referenceGeneration.current) setReferenceError(labels.referenceLoadError);

            case 19:
              _context.prev = 19;

              if (current === referenceGeneration.current) {
                referenceLoadingRef.current = false;
                setReferenceLoading(false);
              }

              return _context.finish(19);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 16, 19, 22]]);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [loadReferenceAssignments, labels.referenceLoadError]);
  useEffect(function () {
    referenceGeneration.current += 1;
    referenceLoadingRef.current = false;
    setReferenceOptions([]);
    setReferenceNextToken(null);
    setReferenceError(null);
    setReferenceLoading(false);
    if (!composerOpen || readOnly) return;
    var timer = setTimeout(function () {
      return loadReferences(referenceSearch);
    }, 250);
    return function () {
      clearTimeout(timer);
      referenceGeneration.current += 1;
    };
  }, [composerOpen, readOnly, classId, referenceSearch, loadReferences]);
  var merge = useCallback(function (records) {
    var map = new Map();
    records.forEach(function (item) {
      if (!map.has(item.id) || map.get(item.id).version < item.version) map.set(item.id, item);
    });
    changes.current.forEach(function (item, id) {
      if (!item) map["delete"](id);else if (!map.has(id) || map.get(id).version <= item.version) map.set(id, item);
    });
    return Array.from(map.values());
  }, []);
  var load = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cursor) {
      var current, page, records, cursors, collect;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!loadingRef.current) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              loadingRef.current = true;
              current = generation.current;
              setLoading(true);
              setError(null);
              _context3.prev = 6;
              _context3.next = 9;
              return api.list(classId, cursor, mode === 'preview' ? 5 : 10);

            case 9:
              page = _context3.sent;

              if (!(mode === 'preview')) {
                _context3.next = 17;
                break;
              }

              records = new Map(page.items.map(function (item) {
                return [item.id, item];
              }));
              cursors = new Set();

              collect = /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(next) {
                  var remaining;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(!next || current !== generation.current || _toConsumableArray(records.values()).filter(function (item) {
                            return !item.pinned;
                          }).length >= 5)) {
                            _context2.next = 2;
                            break;
                          }

                          return _context2.abrupt("return");

                        case 2:
                          if (!cursors.has(next)) {
                            _context2.next = 4;
                            break;
                          }

                          throw new Error(labels.loadAnnouncementsFailed);

                        case 4:
                          cursors.add(next);
                          remaining = 5 - _toConsumableArray(records.values()).filter(function (item) {
                            return !item.pinned;
                          }).length;
                          _context2.next = 8;
                          return api.list(classId, next, remaining);

                        case 8:
                          page = _context2.sent;
                          page.items.forEach(function (item) {
                            return records.set(item.id, item);
                          });
                          _context2.next = 12;
                          return collect(page.nextToken);

                        case 12:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function collect(_x4) {
                  return _ref5.apply(this, arguments);
                };
              }();

              _context3.next = 16;
              return collect(page.nextToken);

            case 16:
              page = {
                items: _toConsumableArray(records.values()),
                nextToken: null
              };

            case 17:
              if (!(current !== generation.current)) {
                _context3.next = 19;
                break;
              }

              return _context3.abrupt("return");

            case 19:
              setItems(function (previous) {
                return merge(cursor ? [].concat(_toConsumableArray(previous), _toConsumableArray(page.items)) : page.items);
              });
              setNextToken(page.nextToken);
              _context3.next = 26;
              break;

            case 23:
              _context3.prev = 23;
              _context3.t0 = _context3["catch"](6);
              if (current === generation.current) setError(labels.loadAnnouncementsFailed);

            case 26:
              _context3.prev = 26;

              if (current === generation.current) {
                loadingRef.current = false;
                setLoading(false);
                setReady(true);
              }

              return _context3.finish(26);

            case 29:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[6, 23, 26, 29]]);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }(), [api, classId, merge, mode, labels.loadAnnouncementsFailed]);
  useEffect(function () {
    generation.current += 1;
    changes.current.clear();
    loadingRef.current = false;
    selectedId.current = null;
    setItems([]);
    setReady(false);
    setNextToken(null);
    setSelected(null);
    setComposerOpen(false);
    setBusy(false);
    load();
    return function () {
      generation.current += 1;
    };
  }, [load]);
  useEffect(function () {
    var target = sentinelRef.current;
    var root = feedRef.current;
    if (mode !== 'full' || !target || !root || !ready || !nextToken || loading || error || busy) return;
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        load(nextToken);
      }
    }, {
      root: root,
      rootMargin: '0px 0px 80px 0px'
    });
    observer.observe(target);
    return function () {
      return observer.disconnect();
    };
  }, [busy, error, load, loading, nextToken, ready, mode]);
  var sorted = useMemo(function () {
    return _toConsumableArray(items).sort(function (left, right) {
      return Number(right.pinned) - Number(left.pinned) || Number(right.createdAt) - Number(left.createdAt) || right.id.localeCompare(left.id);
    });
  }, [items]);

  var profile = function profile(item) {
    return profiles.find(function (p) {
      var _p$id;

      return ((_p$id = p.id) === null || _p$id === void 0 ? void 0 : _p$id.toString()) === item.createdBy;
    }) || ((author === null || author === void 0 ? void 0 : author.id) === item.createdBy ? author : undefined);
  };

  var authorName = function authorName(item) {
    var user = profile(item);
    return [user === null || user === void 0 ? void 0 : user.firstName, user === null || user === void 0 ? void 0 : user.lastName].filter(Boolean).join(' ') || label('teacher');
  };

  var date = function date(item) {
    return new Date(Number(item.createdAt));
  };

  var resetComposer = function resetComposer() {
    setComposerOpen(false);
    setTitle('');
    setContent('');
    setReferences([]);
    setReferenceSearch('');
    setEditing(null);
    setEditorVersion(function (v) {
      return v + 1;
    });
  };

  var canPost = !!content.replace(/<[^>]*>/g, '').replace(/&nbsp;|\s/g, '');

  var remember = function remember(item) {
    changes.current.set(item.id, item);
    setItems(function (previous) {
      return merge([].concat(_toConsumableArray(previous), [item]));
    });
    setSelected(function (previous) {
      return (previous === null || previous === void 0 ? void 0 : previous.id) === item.id ? item : previous;
    });
  };

  var fail = function fail(failure) {
    message.error(failure.status === 409 ? label('announcementConflict') : label('saveAnnouncementFailed'));
    if (failure.status === 409) load();
  };

  var mutate = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(operation, success) {
      var current, _item;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(readOnly || busy)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              current = generation.current;
              setBusy(true);
              _context4.prev = 4;
              _context4.next = 7;
              return operation();

            case 7:
              _item = _context4.sent;
              if (current === generation.current) success(_item);
              _context4.next = 16;
              break;

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](4);

              if (!(current === generation.current)) {
                _context4.next = 16;
                break;
              }

              fail(_context4.t0);
              throw _context4.t0;

            case 16:
              _context4.prev = 16;
              if (current === generation.current) setBusy(false);
              return _context4.finish(16);

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[4, 11, 16, 19]]);
    }));

    return function mutate(_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();

  var post = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var input;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (canPost) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return");

            case 2:
              input = {
                title: title.trim() || null,
                contentHtml: content,
                referenceEntities: references
              };
              _context5.prev = 3;
              _context5.next = 6;
              return mutate(function () {
                return editing ? api.update(classId, editing.id, _objectSpread(_objectSpread({}, input), {}, {
                  version: editing.version
                })) : api.create(classId, input);
              }, function (item) {
                var _feedRef$current;

                remember(item);
                resetComposer();
                if (mode === 'preview') load();
                (_feedRef$current = feedRef.current) === null || _feedRef$current === void 0 ? void 0 : _feedRef$current.scrollTo({
                  top: 0
                });
              });

            case 6:
              _context5.next = 11;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](3);
              return _context5.abrupt("return");

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 8]]);
    }));

    return function post() {
      return _ref7.apply(this, arguments);
    };
  }();

  var edit = function edit(item) {
    setTitle(item.title || '');
    setContent(item.contentHtml);
    setReferences(item.referenceEntities || []);
    setReferenceSearch('');
    setEditing(item);
    setComposerOpen(true);
    setEditorVersion(function (v) {
      return v + 1;
    });
  };

  var pin = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(item) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return mutate(function () {
                return api.pin(classId, item.id, !item.pinned, item.version);
              }, function (updated) {
                remember(updated);
                load();
              });

            case 3:
              _context6.next = 8;
              break;

            case 5:
              _context6.prev = 5;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return");

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 5]]);
    }));

    return function pin(_x7) {
      return _ref8.apply(this, arguments);
    };
  }();

  var remove = function remove(item) {
    return mutate(function () {
      return api["delete"](classId, item.id, item.version);
    }, function () {
      changes.current.set(item.id, null);
      setItems(function (previous) {
        return merge(previous);
      });
      if (mode === 'preview') load();

      if (selectedId.current === item.id) {
        selectedId.current = null;
        setSelected(null);
      }
    });
  };

  var view = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(item) {
      var current, detail;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              current = generation.current;
              selectedId.current = item.id;
              setSelected(item);
              setDetailLoading(true);
              setDetailError(null);
              _context7.prev = 5;
              _context7.next = 8;
              return api.get(classId, item.id);

            case 8:
              detail = _context7.sent;
              if (current === generation.current && selectedId.current === item.id) setSelected(detail);
              _context7.next = 15;
              break;

            case 12:
              _context7.prev = 12;
              _context7.t0 = _context7["catch"](5);
              if (current === generation.current && selectedId.current === item.id) setDetailError(labels.loadAnnouncementsFailed);

            case 15:
              _context7.prev = 15;
              if (current === generation.current && selectedId.current === item.id) setDetailLoading(false);
              return _context7.finish(15);

            case 18:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[5, 12, 15, 18]]);
    }));

    return function view(_x8) {
      return _ref9.apply(this, arguments);
    };
  }();

  var AnnouncementLayout = mode === 'full' ? ClassAnnouncementListLayout : ClassAnnouncementPreviewLayout;
  return /*#__PURE__*/_jsxs(AnnouncementLayout, {
    title: label('announcements'),
    hint: label('announcementsHint'),
    actions: /*#__PURE__*/_jsxs("div", {
      style: {
        display: 'flex',
        gap: 8,
        alignItems: 'center'
      },
      children: [/*#__PURE__*/_jsx(ReloadButton, {
        "aria-label": label('refreshAnnouncements'),
        tooltipTitle: label('refreshAnnouncements'),
        loading: loading,
        handleReload: function handleReload() {
          return load();
        }
      }), !readOnly && /*#__PURE__*/_jsx(PrimaryButton, {
        icon: /*#__PURE__*/_jsx(PlusOutlined, {}),
        "aria-label": label('createAnnouncement'),
        disabled: busy,
        onClick: function onClick() {
          resetComposer();
          setComposerOpen(true);
        },
        children: label('add')
      })]
    }),
    children: [error && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      showIcon: true,
      message: error,
      style: {
        marginBottom: 12
      },
      action: /*#__PURE__*/_jsx(Button, {
        size: "small",
        onClick: function onClick() {
          return load(nextToken);
        },
        children: label('retry')
      })
    }), !ready ? /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }) : /*#__PURE__*/_jsxs(Feed, {
      ref: feedRef,
      $full: mode === 'full',
      "aria-label": label('announcements'),
      children: [!items.length && !error && /*#__PURE__*/_jsx(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE,
        description: label('noAnnouncements')
      }), (mode === 'preview' ? [].concat(_toConsumableArray(sorted.filter(function (item) {
        return item.pinned;
      })), _toConsumableArray(sorted.filter(function (item) {
        return !item.pinned;
      }).slice(0, 5))) : sorted).map(function (item) {
        var _profile;

        return /*#__PURE__*/_jsxs(AnnouncementCard, {
          $full: mode === 'full',
          children: [item.pinned && /*#__PURE__*/_jsx(Tag, {
            color: "blue",
            icon: /*#__PURE__*/_jsx(PushpinOutlined, {}),
            style: {
              marginBottom: 10
            },
            children: label('pinned')
          }), /*#__PURE__*/_jsxs("div", {
            className: "announcement-author",
            children: [/*#__PURE__*/_jsx(Avatar, {
              src: (_profile = profile(item)) === null || _profile === void 0 ? void 0 : _profile.image,
              style: {
                backgroundColor: '#ff8a00',
                flexShrink: 0
              },
              children: authorName(item).charAt(0)
            }), /*#__PURE__*/_jsxs("div", {
              className: "announcement-author-info",
              children: [/*#__PURE__*/_jsx("strong", {
                children: authorName(item)
              }), /*#__PURE__*/_jsx("time", {
                dateTime: date(item).toISOString(),
                children: date(item).toLocaleString()
              })]
            }), !readOnly && /*#__PURE__*/_jsx(Dropdown, {
              trigger: ['click'],
              menu: {
                items: [{
                  key: 'pin',
                  label: label(item.pinned ? 'unpin' : 'pin'),
                  onClick: function onClick() {
                    return pin(item);
                  }
                }, {
                  key: 'edit',
                  label: label('edit'),
                  onClick: function onClick() {
                    return edit(item);
                  }
                }, {
                  key: 'delete',
                  danger: true,
                  label: label('delete'),
                  onClick: function onClick() {
                    return Modal.confirm({
                      title: label('deleteAnnouncement'),
                      content: label('deleteHint'),
                      okText: label('delete'),
                      cancelText: label('cancel'),
                      okButtonProps: {
                        danger: true
                      },
                      onOk: function onOk() {
                        return remove(item);
                      }
                    });
                  }
                }]
              },
              children: /*#__PURE__*/_jsx(Button, {
                type: "text",
                disabled: busy,
                icon: /*#__PURE__*/_jsx(MoreOutlined, {}),
                "aria-label": label('announcementActions')
              })
            })]
          }), item.title && /*#__PURE__*/_jsx("div", {
            className: "announcement-title",
            children: item.title
          }), /*#__PURE__*/_jsx(RichContent, {
            $preview: mode === 'preview',
            dangerouslySetInnerHTML: {
              __html: item.contentHtml
            }
          }), /*#__PURE__*/_jsx(ClassAnnouncementReferences, {
            references: item.referenceEntities,
            resolveReference: resolveReference,
            labels: labels
          }), /*#__PURE__*/_jsx(Button, {
            type: "link",
            style: {
              paddingLeft: 0,
              marginTop: 8
            },
            onClick: function onClick() {
              return view(item);
            },
            children: label('viewDetails')
          })]
        }, item.id);
      }), /*#__PURE__*/_jsx("div", {
        ref: sentinelRef,
        style: {
          textAlign: 'center',
          padding: loading ? '12px 0' : 0,
          minHeight: 1
        },
        children: loading && /*#__PURE__*/_jsx(Spin, {
          size: "small"
        })
      })]
    }), mode === 'preview' && onViewAll && /*#__PURE__*/_jsx(TextLinkButton, {
      style: {
        marginTop: 16,
        alignSelf: 'center'
      },
      onClick: onViewAll,
      children: label('viewAllAnnouncements')
    }), /*#__PURE__*/_jsx(Modal, {
      open: !readOnly && composerOpen,
      onCancel: function onCancel() {
        return !busy && resetComposer();
      },
      title: label(editing ? 'editAnnouncement' : 'createAnnouncement'),
      width: 760,
      destroyOnClose: true,
      maskClosable: false,
      footer: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SecondaryButton, {
          disabled: busy,
          onClick: resetComposer,
          children: label('cancel')
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          onClick: post,
          loading: busy,
          disabled: !canPost,
          children: label(editing ? 'save' : 'post')
        })]
      }),
      children: composerOpen && /*#__PURE__*/_jsx(Composer, {
        children: /*#__PURE__*/_jsxs(Form, {
          layout: "vertical",
          requiredMark: "optional",
          children: [/*#__PURE__*/_jsx(Form.Item, {
            label: label('announcementTitleLabel'),
            htmlFor: "announcement-title",
            children: /*#__PURE__*/_jsx(Input, {
              id: "announcement-title",
              autoFocus: true,
              "aria-label": label('announcementTitleLabel'),
              placeholder: label('announcementTitlePlaceholder'),
              disabled: busy,
              value: title,
              onChange: function onChange(event) {
                return setTitle(event.target.value);
              },
              maxLength: 200
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            label: /*#__PURE__*/_jsx("span", {
              id: "announcement-content-label",
              children: label('announcementContent')
            }),
            required: true,
            htmlFor: "announcement-content",
            children: /*#__PURE__*/_jsx(RichTextEditor, {
              id: "announcement-content",
              autoSave: false,
              disabled: busy,
              onEditorReady: function onEditorReady(editor) {
                editor.view.dom.id = 'announcement-content';
                editor.view.dom.setAttribute('aria-labelledby', 'announcement-content-label');
              },
              content: content,
              onUpdate: setContent,
              placeholder: label('writeAnnouncement'),
              editorLabels: editorLabels
            }, editorVersion)
          }), /*#__PURE__*/_jsxs(Form.Item, {
            label: label('referenceAssignment'),
            htmlFor: "announcement-assignment-reference",
            extra: label('referenceAssignmentHint'),
            children: [/*#__PURE__*/_jsx(Select, {
              id: "announcement-assignment-reference",
              "aria-label": label('referenceAssignment'),
              style: {
                width: '100%'
              },
              showSearch: true,
              allowClear: true,
              disabled: busy || !loadReferenceAssignments,
              placeholder: label('selectReferenceAssignment'),
              loading: referenceLoading,
              filterOption: false,
              onSearch: setReferenceSearch,
              value: (_references$ = references[0]) === null || _references$ === void 0 ? void 0 : _references$.entityId,
              onChange: function onChange(entityId) {
                return setReferences(entityId ? [{
                  entityType: 'ASSIGNMENT',
                  entityId: entityId
                }] : []);
              },
              onPopupScroll: function onPopupScroll(event) {
                var target = event.target;
                if (referenceNextToken && target.scrollHeight - target.scrollTop - target.clientHeight < 40) loadReferences(referenceSearch, referenceNextToken);
              },
              options: [].concat(_toConsumableArray(references[0] && !referenceOptions.some(function (item) {
                return item.entityId === references[0].entityId;
              }) ? [{
                value: references[0].entityId,
                label: "".concat(label('referenceAssignment'), " (").concat(references[0].entityId, ")")
              }] : []), _toConsumableArray(referenceOptions.map(function (item) {
                return {
                  value: item.entityId,
                  label: "".concat(item.title, " \xB7 ").concat(item.typeLabel)
                };
              }))),
              notFoundContent: referenceLoading ? /*#__PURE__*/_jsx(Spin, {
                size: "small"
              }) : label('noReferenceAssignments')
            }), referenceError && /*#__PURE__*/_jsx(Alert, {
              type: "error",
              showIcon: true,
              message: referenceError,
              style: {
                marginTop: 8
              },
              action: /*#__PURE__*/_jsx(Button, {
                size: "small",
                onClick: function onClick() {
                  return loadReferences(referenceSearch, referenceNextToken || undefined);
                },
                children: label('retry')
              })
            }), /*#__PURE__*/_jsx(ClassAnnouncementReferences, {
              references: references,
              resolveReference: resolveReference,
              labels: labels
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Modal, {
      open: !!selected,
      onCancel: function onCancel() {
        selectedId.current = null;
        setSelected(null);
      },
      footer: null,
      title: (selected === null || selected === void 0 ? void 0 : selected.title) || label('announcements'),
      width: 760,
      children: detailLoading ? /*#__PURE__*/_jsx(Skeleton, {
        active: true
      }) : detailError ? /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: detailError,
        showIcon: true
      }) : selected && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("p", {
          style: {
            color: '#718096'
          },
          children: [authorName(selected), " \xB7 ", date(selected).toLocaleString()]
        }), /*#__PURE__*/_jsx(RichContent, {
          dangerouslySetInnerHTML: {
            __html: selected.contentHtml
          }
        }), /*#__PURE__*/_jsx(ClassAnnouncementReferences, {
          references: selected.referenceEntities,
          resolveReference: resolveReference,
          labels: labels
        })]
      })
    })]
  });
};